module.exports = __webpack_public_path__ + "static/media/prizm-trail.e920693e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/screens/prizm/prizm-trail.mp4
// module id = 3547
// module chunks = 0